export const NumberOfAlertsToDisplay = 20; // Prevent querying for and displaying a large number of Alerts.
